import { BASE, request } from "./client";

export interface TagSet {
  prompt: string;
  tags: string[];
}

export function getTagSet(playbookId: string): Promise<TagSet> {
  return request(`/playbooks/${playbookId}/tags`);
}

export function getSessionTags(playbookId: string): Promise<{ tags: string[] }> {
  return request(`/playbooks/${playbookId}/session-tags`);
}

export function generateTagSet(playbookId: string, prompt: string, count: number): Promise<{ tags: string[] }> {
  return request(`/playbooks/${playbookId}/tags/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt, count }),
  });
}

export function saveTagSet(playbookId: string, data: TagSet): Promise<{ playbook_id: string; tag_count: number }> {
  return request(`/playbooks/${playbookId}/tags`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export interface CacheNode {
  key: string;
  text: string;
  description: string;
  has_audio: boolean;
}

export interface CacheStats {
  pregenerated_count: number;
  runtime_count: number;
  total_count: number;
  voice_ids: string[];
}

export interface CacheStatus {
  nodes: CacheNode[];
  stats: CacheStats;
}

export function getCacheStatus(playbookId: string): Promise<CacheStatus> {
  return request(`/playbooks/${playbookId}/cache`);
}

export function cacheAudioUrl(playbookId: string, voiceKey: string, nodeKey: string): string {
  return `${BASE}/playbooks/${playbookId}/cache/${voiceKey}/${nodeKey}/audio`;
}

export function regenerateCacheNode(playbookId: string, nodeKey: string): Promise<{ node_key: string; size: number }> {
  return request(`/playbooks/${playbookId}/cache/nodes/${nodeKey}/regenerate`, { method: "POST" });
}
